import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconChats({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="2 2 20 20" fill="none">
      <Path
        fill={fill}
        d="M17.9986 2.7273C20.0535 2.7273 21.8922 4.5425 21.8923 6.7437V14.7167C21.8311 16.9035 20.0422 18.5107 18.0649 18.6039H12.2783C11.7446 18.9345 8.2317 21.1337 7.8688 21.2112C7.5062 21.2885 7.1524 21.343 6.6784 21.0522C6.2043 20.7611 6.1336 20.425 6.0688 20.0671C6.0048 19.7134 6.0349 18.6234 6.0357 18.5962C3.8448 18.5959 2.2311 16.7739 2.1077 14.8879V6.5151C2.2771 4.2857 4.0029 2.8563 5.9573 2.7273H17.9986ZM7.0781 11.7042C6.5005 11.7042 6.0324 12.1723 6.0324 12.75C6.0325 13.3276 6.5005 13.7958 7.0781 13.7958H12.2463C12.3706 13.7957 12.4891 13.7716 12.5997 13.7317C13.0343 13.6157 13.3548 13.221 13.355 12.75C13.355 12.2848 13.0426 11.8931 12.6162 11.7716C12.5012 11.728 12.3766 11.7043 12.2463 11.7042H7.0781ZM7.0605 7.0893C6.4987 7.0902 6.0429 7.5468 6.0434 8.1086C6.0436 8.2942 6.0944 8.4679 6.1814 8.6177C6.3481 8.9737 6.7088 9.2204 7.1278 9.2206H9.3652C9.6629 9.2206 9.9312 9.0956 10.1216 8.896C10.3517 8.709 10.4985 8.4237 10.4982 8.1042C10.4975 7.5424 10.0417 7.0869 9.48 7.0871L7.0605 7.0893Z"
      />
    </Svg>
  )
}
